import { chakra } from '@chakra-ui/react'
import { Link } from 'gatsby'

const ChakraLink = chakra(Link)

export default ChakraLink
